import React, { useEffect } from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";

import { withTranslation } from "react-i18next";
import crossIcon from "assets/images/cross.svg";
import styles from "accountOwner/pages/Notes/Notes.module.scss";
import Button from "components/Button";
import Text from "components/Text";
import { useCloseShift } from "repositories/scheduler-repository";
import toast from "react-hot-toast";

const CloseShiftRequestModal = ({
  t,
  isModalOpen,
  closeModal,
  eventDetails,
  seteventDetails,
}) => {
  const { isLoading, mutate, data } = useCloseShift();
  useEffect(() => {
    if (data?.status) {
      seteventDetails((prev) => ({
        ...prev,
        isShiftClosed: data.status,
      }));
      closeModal();
      toast.success(t("scheduler.closeSuccess"));
    }
  }, [data?.status]);
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      className="modal-lg modal-dialog-centered"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <div className={styles.alert_popup_content_wrapper}>
          <h2 className="page-title text-center mt-3">
            {t("scheduler.closeShiftNewReason")}
          </h2>
          <Text
            size="16px !important"
            weight="300"
            color="#535B5F"
            marginTop="30px"
            lineHeight="24px"
            className="text-center"
          >
            {t("scheduler.closeShiftModalDescription")}
          </Text>

          <div className={styles.main_btn_container}>
            <Button
              onClick={() => {
                mutate({ id: eventDetails?.id });
              }}
              disabled={isLoading}
              className="w-50"
            >
              {isLoading ? (
                <div className="loader-container text-center">
                  <Spinner animation="border" className="loader-spinner" />
                </div>
              ) : (
                t("scheduler.closeShift")
              )}
            </Button>
            <Button borderedSecondaryNew onClick={closeModal} className="w-50">
              <span>{t("cancel")}</span>
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(CloseShiftRequestModal);
